import { render, staticRenderFns } from "./import.vue?vue&type=template&id=201b993b&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"
import style0 from "./import.vue?vue&type=style&index=0&id=201b993b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201b993b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('201b993b')) {
      api.createRecord('201b993b', component.options)
    } else {
      api.reload('201b993b', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=201b993b&scoped=true", function () {
      api.rerender('201b993b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overseasInventory/overseasInventoryQuery/import.vue"
export default component.exports